import http from "../../utils/http";


// financeAccountSub 목록 가져오기
export const getFinanceAccountSubList = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/tax-portal/finance-account-sub/list`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// financeAccountSub 등록
export const createFinanceAccountSub = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/tax-portal/finance-account-sub`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// financeAccountSub 수정
export const putFinanceAccountSub = (idx, params) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/tax-portal/finance-account-sub/${idx}`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// financeAccountSub 내거 가져오기
export const getMyFinanceAccountSub = () => {
  return new Promise((resolve, reject) => {
    http
      .get(`/tax-portal/finance-account-sub/my`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
